import { $authHost } from '.'
import {
	NotificationsResponse
} from '../helpers/types/notification'

export const fetchNotifications = async (
	page = 1,
	limit = 20
): Promise<NotificationsResponse> => {
	const { data } = await $authHost.get('/notification', {
		params: { page, limit }
	})
	return data as NotificationsResponse
}

export const markNotificationRead = async (id: string): Promise<void> => {
	await $authHost.patch(`/notification/${encodeURIComponent(id)}/read`)
}

export const markAllNotificationsRead = async (): Promise<void> => {
	await $authHost.patch('/notification/read-all')
}
